export const BUSINESS_EXPORT_DATA_SETTING_CONSTS = {
  SCOPE_TYPE_PERSONAL: 1,
  SCOPE_TYPE_BUSINESS: 2,

  FORMAT_EXCEL: 1,
  FORMAT_GOOGLE_SHEET: 2,

  // Define type dùng cho màn hình nào

}


export const typesName = {}
